/// <amd-module name="Wit/QueriesHub/Common/Components/SaveWorkItemsDialog" />
import * as React from "react";
import { ObservableArray } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { Dialog } from "VSSUI/Dialog";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import * as Resources from "Wit/QueriesHub/Resources";
import { IWorkItemBulkSaveResult } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export interface ISaveWorkItemsDialogProps {
    results: ObservableArray<IWorkItemBulkSaveResult>;
    onDismiss: () => void;
}

export function SaveWorkItemsDialog(props: ISaveWorkItemsDialogProps) {
    return (
        <Observer results={props.results}>
            {(observableProps: { results: IWorkItemBulkSaveResult[] }) => {
                let title = Resources.SavingWorkItemsTitle;
                let content = <Spinner className="padding-vertical-8" size={SpinnerSize.large} />;
                if (observableProps.results.length) {
                    const itemsWithError = observableProps.results.filter(item => !!item.error).length;
                    if (itemsWithError == 0) {
                        // all items saved successfully
                        title = Resources.SavedItemsSuccessfullyTitle;
                        content = (
                            <div className="scroll-auto flex-grow flex-column">
                                <div>
                                    <p>{format(Resources.SuccessfullySavedItems, observableProps.results.length)}</p>
                                </div>
                            </div>
                        );
                    } else {
                        // if (itemsWithError > 0 && itemsWithError != observableProps.results.length) {
                        title = Resources.ErrorSavingWorkItemsTitle;
                        const text =
                            itemsWithError == observableProps.results.length
                                ? format(Resources.FailedToSaveComment, itemsWithError)
                                : `${format(Resources.SuccessfullySavedItems, observableProps.results.length - itemsWithError)} ${format(
                                      Resources.FailedToSaveComment,
                                      itemsWithError
                                  )}`;

                        const innerContent: JSX.Element[] = [];
                        observableProps.results.forEach(item => {
                            if (item.error) {
                                innerContent.push(
                                    <div key={`${item.workItem.id}`}>
                                        <p>{`${format(Resources.WorkItemErrorLabel, item.workItem.id)} ${item.error.message}`}</p>
                                    </div>
                                );
                            }
                        });

                        content = (
                            <div className="scroll-auto flex-grow flex-column">
                                <div>
                                    <p>{text}</p>
                                </div>
                                {innerContent}
                                <div>
                                    <p>{Resources.FailedToSaveFixComment}</p>
                                </div>
                            </div>
                        );
                    }
                }

                return (
                    <Dialog
                        titleProps={{ text: title }}
                        onDismiss={() => onDismiss(props)}
                        footerButtonProps={[
                            {
                                text: Resources.OK,
                                onClick: () => onDismiss(props),
                                primary: true
                            }
                        ]}
                        resizable={true}
                    >
                        {content}
                    </Dialog>
                );
            }}
        </Observer>
    );
}

function onDismiss(props: ISaveWorkItemsDialogProps) {
    props.results.value = [];
    props.onDismiss();
}
